import SOPLine from './SOPLine';

export default SOPLine;
